<div class="flex w-full my-4">
  <soft-input
    placeholder="Artikel suchen"
    #input
    (keydown.enter)="search(input.value())"
    class="h-full"
  >
    @if ((input.value?.length ?? 0) > 0) {
      <div class="cursor-pointer" (click)="input.value.set(''); onEmptyTextfield()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </div>
    }
  </soft-input>
  <button
    class="soft-button primary rounded-r-md"
    [disabled]="(input?.value()?.length || 0) < 3"
    (click)="search(input.value())"
  >
    <soft-icon name="fa-solid fa-magnifying-glass" class="text-sm"></soft-icon>
  </button>
</div>
@if (itemsWithFavorite$ | async; as items) {
  @if (items.length > 0 || (loading$ | async)) {
    <soft-artikel-suchergebnis
      [loading]="loading$ | async"
      [searchInput]="searchText$ | async"
      [items]="items"
      (addToFavorites)="onAddToFavorites($event)"
      (removeFromFavorites)="onRemoveFromFavorites($event)"
      (selectArtikel)="selectArtikel.emit($event)"
    ></soft-artikel-suchergebnis>
  } @else {
    <soft-artikel-suchverlauf
      (selectVerlauf)="input.value.set($event); search($event)"
    ></soft-artikel-suchverlauf>
  }
} @else {
  <soft-artikel-suchverlauf
    (selectVerlauf)="input.value.set($event); search($event)"
  ></soft-artikel-suchverlauf>
}
